var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div data-bind="attr: { id: elementId }"></div>';
}
return __p;
};
